export * from './project-item';
export * from './project-presenter';

import { ProjectItemComponent } from './project-item';
import { ProjectPresenterComponent } from './project-presenter';




export const ProjectAtoms = [
    ProjectItemComponent,
    ProjectPresenterComponent
]